import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyDu99IoowzRXuP6kWWY28724GuzfzCOSC0",
    authDomain: "minefloat-redirect.firebaseapp.com",
    projectId: "minefloat-redirect",
    storageBucket: "minefloat-redirect.firebasestorage.app",
    messagingSenderId: "859441730339",
    appId: "1:859441730339:web:c5dcea1545affacf9d3296",
    measurementId: "G-1SH1WJTZ04"
  };
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://europe-west1-minefloat-redirect.cloudfunctions.net'
  : 'http://localhost:5001/minefloat-redirect/europe-west1'; 